import { useCallback, useEffect, useState } from "react";
import './number-test-display.css'
//const nums = [4, 6, 3, 14];
let timeout;
let interval;

export default function NumberTestDisplay({randomNumberArray, hideNumbersAndDisplayPad}) {
  const [n, setN] = useState(0);
  const [hidden, setHidden] = useState(false);
  const rotateNumbers = useCallback(() => {
    setN((prevN) => {
      let nextN = prevN + 1;

      if (nextN >= randomNumberArray.length) {
        nextN = 0;
        //randomNumberArray = []
        // clearInterval(interval);
        // clearTimeout(timeout);
        hideNumbersAndDisplayPad()
      }
      return nextN;
    });
    setTimeout(() => {
      setHidden(true);
    }, 900);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    //console.log("randomNumberArray in Number display Component", randomNumberArray)
    interval = setInterval(() => {
      setHidden(false);
      rotateNumbers();
      return () => {
        clearInterval(interval);
        clearTimeout(timeout);
      };
    }, 1000);

    setTimeout(() => {
      setHidden(true);
    }, 900);
    // eslint-disable-next-line
  }, [rotateNumbers]);
  return (
    <>
      {/* <h1>この番号順を覚えてください。</h1> */}
      <div className="random-number-display">{!hidden && randomNumberArray[n]}</div>
    </>
  );
}

